import gql from "graphql-tag";

export default gql`
  mutation ExportKpis($tickerSymbol: TickerSymbol!, $token: String!, $language: ISO6391LanguageCode, $format: String) {
    exportKpis(tickerSymbol: $tickerSymbol, token: $token, language: $language, format: $format)
  }
`;
